module.exports = __webpack_public_path__ + "static/media/icon-offer.c12b5202.svg";